export const auth = {
  login: {
    heading: 'ログイン',
    subtitle: 'EachTeachへようこそ',
    emailLabel: 'メールアドレス',
    emailPlaceholder: 'your@email.com',
    passwordLabel: 'パスワード',
    passwordPlaceholder: 'パスワード',
    forgotPassword: 'パスワードをお忘れですか？',
    invalidCredentials: 'メールアドレスまたはパスワードが正しくありません',
    submitting: 'ログイン中...',
    submit: 'ログイン',
    noAccount: 'アカウントをお持ちでないですか？',
    register: '新規登録',
  },

  forgotPassword: {
    heading: 'パスワードをお忘れですか？',
    intro: '登録済みのメールアドレスを入力してください。パスワード再設定のリンクをお送りします。',
    sendError: 'メール送信に失敗しました。メールアドレスを確認してください。',
    sentTitle: 'メールを送信しました',
    sentBody: '{{email}} 宛にパスワード再設定リンクを送りました。メールをご確認ください。',
    backToLogin: 'ログイン画面に戻る',
    emailLabel: 'メールアドレス',
    emailPlaceholder: 'your@email.com',
    submitting: '送信中...',
    submit: 'リセットリンクを送信',
  },

  resetPassword: {
    linkExpired: 'リセットリンクの有効期限が切れています。もう一度パスワードリセットをリクエストしてください。',
    linkInvalid: '無効なリンクです。もう一度パスワードリセットをリクエストしてください。',
    passwordMismatch: 'パスワードが一致しません',
    passwordMin: 'パスワードは8文字以上で入力してください',
    updateFailed: 'パスワードの更新に失敗しました。もう一度お試しください。',
    linkErrorTitle: 'リンクが無効です',
    requestAgain: '再度リセットをリクエスト',
    verifying: '認証情報を確認中...',
    heading: '新しいパスワードを設定',
    subtitle: '8文字以上のパスワードを入力してください',
    successTitle: 'パスワードを更新しました！',
    successBody: 'ログイン画面に移動します...',
    newPasswordLabel: '新しいパスワード',
    newPasswordPlaceholder: '8文字以上',
    confirmLabel: 'パスワード（確認）',
    confirmPlaceholder: 'もう一度入力',
    submitting: '更新中...',
    submit: 'パスワードを更新する',
  },
};
